<section class="help-detail-page container">
  <!-- section header -->
  <div class="help-detail-page__header">
    <!-- title -->
    <h1 class="help-detail-page__title">
      {{ helpDetailsData?.topic?.title | translateData }}
    </h1>
    <!-- icons -->
    <div class="help-detail-page__box-icons">
      <div class="help-detail-page__box">
        <!-- share btn -->
        <pwj-button
          variant="primary-outlined"
          color="white"
          size="large"
          (click)="openQrCodeDialog(pageLink)">
          <i
            class="iconsax quick-order-details__share-icon"
            icon-name="share"></i>
          <p class="help-detail-page__box-text">
            {{ 'global.share' | translate }}
          </p>
        </pwj-button>
      </div>
    </div>
  </div>
  <!-- help video -->
  <div class="help-details-page__video">
    <pwj-video-player
      [videoPreviewSrc]="
        helpDetailsData?.video?.url | imageSource
      "></pwj-video-player>
  </div>

  <!-- description -->
  <p class="help-detail-page__description">
    {{ helpDetailsData?.description | translateData }}
  </p>
</section>
